module.exports = __webpack_public_path__ + "static/media/16UNODC40.b4618ec4.jpg";